var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideStatic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light-Pink-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 7.5,
    fill: "url(#paint0_linear_16_3626)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 7.5,
    fill: "url(#paint1_linear_16_3626)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 7.5,
    fill: "url(#paint2_linear_16_3626)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glass",
    filter: "url(#filter0_bi_16_3626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68341 16.9299L17.542 2.69966C17.8704 2.30554 18.5085 2.6026 18.4183 3.10764L16.7857 12.25H23.9325C24.3564 12.25 24.588 12.7444 24.3166 13.0701L12.646 27.0747C12.306 27.4828 11.6485 27.1493 11.7767 26.6339L13.9881 17.75H6.06752C5.6436 17.75 5.41202 17.2556 5.68341 16.9299Z",
    fill: "#F1F1F1",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6627 12.228L16.6364 12.375H16.7857H23.9325C24.2504 12.375 24.4241 12.7458 24.2206 12.9901L12.55 26.9947C12.295 27.3007 11.8018 27.0506 11.898 26.6641L14.1094 17.7802L14.148 17.625H13.9881H6.06752C5.74958 17.625 5.5759 17.2542 5.77944 17.0099L17.638 2.77968C17.8843 2.48409 18.3629 2.70689 18.2952 3.08567L16.6627 12.228Z",
    stroke: "url(#paint3_linear_16_3626)",
    strokeOpacity: 0.1,
    strokeWidth: 0.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_16_3626",
    x: 2.56656,
    y: -0.482178,
    width: 24.8669,
    height: 30.7393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_3626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_3626",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16_3626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_3626",
    x1: 8.125,
    y1: 10.5,
    x2: 24.4762,
    y2: 12.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_3626",
    x1: 7.5,
    y1: 15.005,
    x2: 22.5,
    y2: 15.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A91B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_3626",
    x1: 21.58,
    y1: 22.0841,
    x2: 5.72792,
    y2: 4.66263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#FE7B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC2A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_3626",
    x1: 5.625,
    y1: 2.5,
    x2: 25,
    y2: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD84DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD6FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideStatic);
export default __webpack_public_path__ + "static/media/side-static.2f1d1efd8ec3d6c5f84b140d095fce14.svg";
export { ForwardRef as ReactComponent };